import { majors } from "#/utils/legacyData/majorGradeLevel";

export enum StatusPack {
  ACTIVE = 1,
  WILL_BE_ACTIVATED = 2,
  DISABLED = 3,
  HAS_NOT_ACCESS_DEMO = 4,
  SUSPEND = 5,
  NO_DEMO_OR_ORIGINAL_CONTRACT = 6,
  USING_FREE_DEMO = 7,
}
export const gradesItemsValues = {
  0: "اول",
  1: "دوم",
  2: "سوم",
  3: "چهارم",
  5: "پنجم",
  6: "ششم",
  7: "هفتم",
  8: "هشتم",
  9: "نهم",
  10: "دهم",
  11: "یازدهم",
  12: "دوازدهم",
};
export const majorsItemsValues = {
  [majors.mathematics]: "ریاضی",
  [majors.science]: "تجربی",
  [majors.humanities]: "انسانی",
};

export enum ContentType {
  PRACTICE = 1,
  LECTURE = 2,
  EXAM = 3,
  VIDEO = 4,
  VOICE = 5,
  PDF = 6,
  DESCRIPTIVE_PRACTICE = 7,
  PRACTICE_EXAM = 8,
}
